// True only inside a real browser iframe. Returns false in React Native, Node,
// and any environment where `window.self`/`window.top` aren't the browser-shaped
// references. React Native polyfills `window` but does not define `document`, so
// we gate on `document` first (RN has `window.top === undefined`, which would
// otherwise make `window.self !== window.top` a false positive). The try/catch
// is defensive against sandboxed frames where `window.top` access throws.
export const isInIframe = (): boolean => {
  if (typeof window === 'undefined') return false
  if (typeof document === 'undefined') return false
  try {
    return window.self !== window.top
  } catch {
    return false
  }
}
